import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11.369",
  height: "15.503"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M3.273 0a1.215 1.215 0 0 0-1.206 1.206v1.55h-.861A1.215 1.215 0 0 0 0 3.962V14.3a1.215 1.215 0 0 0 1.206 1.2H8.1a1.215 1.215 0 0 0 1.2-1.2v-1.55h.861a1.215 1.215 0 0 0 1.206-1.206V3.617a.517.517 0 0 0-.151-.366l-3.1-3.1A.517.517 0 0 0 7.752 0zm0 1.034h3.962v2.583a.517.517 0 0 0 .517.517h2.584v7.407a.162.162 0 0 1-.172.172h-6.89a.162.162 0 0 1-.172-.172V1.206a.162.162 0 0 1 .171-.172zm5 .732L9.6 3.1H8.268zM1.206 3.79h.861v7.752a1.215 1.215 0 0 0 1.206 1.206h5V14.3a.162.162 0 0 1-.172.172h-6.89a.162.162 0 0 1-.172-.172V3.962a.162.162 0 0 1 .167-.172z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };